const FJFaceSwapData = {
    THOSE_ORIGIN_IMAGES: [
        {
            name: 'origin-13',
            type: 'limit',
        },
        {
            name: 'origin-14',
            type: 'limit',
        },
        {
            name: 'origin-15',
            type: 'limit',
        },
        {
            name: 'origin-16',
            type: 'limit',
        },
        {
            name: 'origin-10',
        },
        {
            name: 'origin-11',
        },
        {
            name: 'origin-6',
        },
        {
            name: 'origin-9',
        },
        {
            name: 'origin-4',
        },
        {
            name: 'origin-2',
        },
        {
            name: 'origin-12',
        },
        {
            name: 'origin-1',
        },
        {
            name: 'origin-7',
        },
        {
            name: 'origin-8',
        },
        {
            name: 'origin-3',
        },
        {
            name: 'origin-5',
        },
    ],
    THOSE_TARGET_IMAGES: [
        {
            name: 'target-1',
        },
        {
            name: 'target-2',
        },
        {
            name: 'target-3',
        },
        {
            name: 'target-4',
        },
    ],
};

export default FJFaceSwapData;
